import { ColorNordicGrey1, Spacing8, Spacing16, Spacing24 } from 'autogen/design-tokens/tokens';
import { css } from 'styled-components';

const defaultTheme = {
    Wrapper: css`
        border: 0 solid ${ColorNordicGrey1};
        border-top-width: 1px;
        border-bottom-width: 0;
    `,
    StyledPictureWithLink: css`
        display: flex;
        padding: ${Spacing24} ${Spacing16};
        justify-content: center;
        border-bottom: 1px solid ${ColorNordicGrey1};

        img {
            max-height: 50px;
            object-fit: contain;
        }
    `,
    ProductAccordionItem: {
        AccordionButton: css`
            padding-left: 0;
            padding-right: 0;
        `,
        ContentContainer: css``
    }
};

export default defaultTheme;
